import type { SchemaViewerFieldWrapperProps } from "./schema-viewer-field.type";

import { SchemaViewerFieldLabel } from "../schema-viewer-field-label";
import { SchemaViewerFormItem } from "../schema-viewer-form-item";

import { SchemaViewerField } from "./schema-viewer-field.component";

export const SchemaViewerFieldWrapper = ({
  schema,
  form,
  disabled,
  isVisible,
}: SchemaViewerFieldWrapperProps) => {
  // Do not add `FormItem` for `label` field
  if (schema.type === "label") {
    return isVisible ? <SchemaViewerFieldLabel schema={schema} /> : null;
  }

  return (
    <SchemaViewerFormItem schema={schema} isVisible={isVisible}>
      <SchemaViewerField schema={schema} form={form} disabled={disabled} />
    </SchemaViewerFormItem>
  );
};
